<div class="container-fluid glb-popup">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"> </p-toast>
  <p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
  ></p-confirmDialog>

  <button
    mat-icon-button
    [mat-dialog-close]="true"
    style="float: right; top: -50px; background-color: transparent"
    >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr />
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
          <div class="w-100" style="
              text-align: center;
              background-color: yellow;
              padding: 5px;
              margin-bottom: 15px;">
              <p>
                <b>{{ formAlert }}</b>
              </p>
            </div>
          </div>
        }
      </div>
      <div class="row d-flex justify-content-between">
        <div class="col-10 row py-0">
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-4">
              @if (propertyLeadProperties?.length > 0) {
                <p-dropdown [options]="propertyLeadProperties"
                  formControlName="propertyLeadProfileId" appendTo="body" optionLabel="displayLabel"
                  optionValue="propertyLeadProfileId" (onChange)="changePropertyLeadProfile($event)"
                  [filter]="true" filterBy="displayLabel" [showClear]="false"
                  placeholder="Select Property of propertyLeadProfile" [disabled]="disabledPropertySelection" >
                </p-dropdown>
              }
              <label for="Select Property of propertyLeadProfile">Select Property of
              propertyLeadProfile</label>
              @for (validation of validationMessages.propertyLeadProfileId; track validation) {
                <span>
                  @if (form1.get('propertyLeadProfileId').hasError(validation.type) && (form1.get('propertyLeadProfileId').dirty || form1.get('propertyLeadProfileId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name" optionValue="value"
          placeholder="status"></p-dropdown>
          <label for="status">Status</label>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-12">
        <label for="opsNotes"><strong>Operational Notes :</strong></label>
        <span class="p-float-label w-100 mb-3">
          <!-- <ckeditor [editor]="editor" formControlName="opsNotes" id="opsNotes" (ready)="onReady($event)"></ckeditor> -->
          <editor
            formControlName="opsNotes"
            id="opsNotes"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
          </editor>
          @for (validation of validationMessages.opsNotes; track validation) {
            <span>
              @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>
  </div>
  <hr />
  <div class="row mb-1">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (isEditForm) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete</button>
          }
        </div>
        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Close</button>
          @if (!ownerPropertyDetailId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
          }
          @if (ownerPropertyDetailId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">
              @if (isEditForm) {
                <span>Update</span>
                } @if (!isEditForm) {
                <span>Add</span>
              }</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
